import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A4EFE1A4-034F-473F-9076-D8DFF6167067
 * name cellphone-nfc
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-nfc.svg
 * tags
 * - Automotive 
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const CellphoneNfcIcon = createSvgIcon(<><path d="M2,16V18A5,5 0 0,1 7,23H9A7,7 0 0,0 2,16M2,20V23H5A3,3 0 0,0 2,20M2,12V14A9,9 0 0,1 11,23H13C13,16.92 8.08,12 2,12M17,1H7A2,2 0 0,0 5,3V10.37C5.69,10.53 6.36,10.74 7,11V5H17V18H13.97C14.5,19.25 14.81,20.59 14.92,22H17A2,2 0 0,0 19,20V3A2,2 0 0,0 17,1Z" /></>, 'CellphoneNfcIcon');
export default CellphoneNfcIcon